/*
  PriceList_v1.js propTypes
  extracted from http://localhost:3000/documentation/resources/oaspec.json
  on 2018-04-23T13:43:27.206Z
*/

import { shape } from 'prop-types'

import Price_v1 from './Price_v1'

export default {
  retailPrice: shape(Price_v1),
  listPrice: shape(Price_v1),
}
